module.exports = __webpack_public_path__ + "img/add_address.1c05ebcf.svg";